const DATE_FORMAT = 'DD/MM/YYYY HH:mm';

module.exports = {
  DATE_FORMAT,
};
